import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";

// Pages
import LandingPage from "@/pages/LandingPage";
import ContactPage from "@/pages/ContactPage";
import EstimatePage from "@/pages/EstimatePage";
import CustomerPortal from "@/pages/CustomerPortal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ContractView from "@/pages/ContractView";
import InvoiceView from "@/pages/InvoiceView";

// Admin Pages
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Customers from "@/pages/admin/Customers";
import CustomerDetail from "@/pages/admin/CustomerDetail";
import Leads from "@/pages/admin/Leads";
import Invoices from "@/pages/admin/Invoices";
import Contracts from "@/pages/admin/Contracts";
import Communications from "@/pages/admin/Communications";
import Reports from "@/pages/admin/Reports";
import Settings from "@/pages/admin/Settings";
import PortalUsers from "@/pages/admin/PortalUsers";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/estimate" element={<EstimatePage />} />
          <Route path="/portal" element={<CustomerPortal />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/contract/:token" element={<ContractView />} />
          <Route path="/invoice/:token" element={<InvoiceView />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="customers" element={<Customers />} />
            <Route path="customers/:id" element={<CustomerDetail />} />
            <Route path="leads" element={<Leads />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="contracts" element={<Contracts />} />
            <Route path="portal-users" element={<PortalUsers />} />
            <Route path="communications" element={<Communications />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
